import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import ProjectDashboard from './pages/ProjectDashboard';
import ProjectSetup from './pages/ProjectSetup';
import Pricing from './pages/Pricing';
import Docs from './pages/Docs';
import GamePlayer from './pages/GamePlayer';
import AssetManager from './pages/Admin/AssetManager';
import FeaturedGames from './pages/Admin/FeaturedGames';
import ServerSettings from './pages/Admin/ServerSettings';
import UnitsPage from './pages/Admin/Units/UnitsPage';
import AdminRoute from './components/AdminRoute';
import { useAuth } from './context/AuthContext';

function PrivateRoute({ element }: { element: JSX.Element }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  return isAuthenticated ? element : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/docs" element={<Docs />} />
      <Route path="/play/:projectId" element={<GamePlayer />} />
      <Route path="/play/:projectId/version/:versionId" element={<GamePlayer />} />
      <Route path="/project-setup" element={<PrivateRoute element={<ProjectSetup />} />} />
      <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
      <Route path="/projects/:id" element={<PrivateRoute element={<ProjectDashboard />} />} />
      <Route path="/admin/assets" element={<AdminRoute element={<AssetManager />} />} />
      <Route path="/admin/featured" element={<AdminRoute element={<FeaturedGames />} />} />
      <Route path="/admin/settings" element={<AdminRoute element={<ServerSettings />} />} />
      <Route path="/admin/units" element={<AdminRoute element={<UnitsPage />} />} />
    </Routes>
  );
}
